module.exports = __webpack_public_path__ + "img/google11.a786fb96.jpg";